import { Component, inject } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { RouterOutlet } from "@angular/router";
import { SplashComponent } from "./core/components/splash/splash.component";
import { AuthStore } from "./core/stores/auth.store";

@Component({
    selector: "nice-ops-root",
    imports: [RouterOutlet, SplashComponent],
    templateUrl: "./app.template.html",
    styleUrl: "./app.style.scss"
})
export class AppComponent {
    protected readonly authStore = inject(AuthStore);
    protected readonly iconRegistry = inject(MatIconRegistry);
    protected readonly sanitizer = inject(DomSanitizer);

    constructor() {
        this.iconRegistry.addSvgIconSetInNamespace(
            "streamline-regular",
            this.sanitizer.bypassSecurityTrustResourceUrl("/assets/svgs/regular.svg")
        );
        this.iconRegistry.addSvgIconSetInNamespace(
            "streamline-bold",
            this.sanitizer.bypassSecurityTrustResourceUrl("/assets/svgs/bold.svg")
        );
    }
}
